import { useGamesBySlugWithQueryParams } from '@/hooks/games/useGamesBySlugWithQueryParams';
import styles from './styles.module.scss';
import { ErrorCard, StaggerAnimation } from '@starsoft/common/components';
import GameStatisticsContentRow from './Row';
import useTranslation from 'next-translate/useTranslation';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export default function GameDetailsStatistics() {
  const { t } = useTranslation('common');
  const {
    game,
    isLoading: isLoadingGameData,
    error,
    refetch,
  } = useGamesBySlugWithQueryParams();

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <StaggerAnimation
      direction="column"
      stagger={0.15}
      staggerDirection="up"
      className={styles.container}
    >
      <GameStatisticsContentRow
        title={t('house_edge')}
        isLoading={isLoadingGameData}
        value={`${Number(100 - Number(getMoneyOrAmount(game?.rtp) ?? 0))?.toFixed?.(2)}%`}
      />
      <GameStatisticsContentRow
        title={t('rtp')}
        isLoading={isLoadingGameData}
        value={`${Number(getMoneyOrAmount(game?.rtp) ?? 0)?.toFixed(2)}%`}
      />
      <GameStatisticsContentRow
        title={t('max_win')}
        isLoading={isLoadingGameData}
      />
      <GameStatisticsContentRow
        title={t('hit_rate')}
        isLoading={isLoadingGameData}
      />
      <GameStatisticsContentRow
        title={t('reel_design')}
        isLoading={isLoadingGameData}
      />
      <GameStatisticsContentRow
        title={t('volatillity')}
        isLoading={isLoadingGameData}
      />
      <GameStatisticsContentRow
        title={t('lucky_spins')}
        isLoading={isLoadingGameData}
      />
      <GameStatisticsContentRow
        title={t('stakes_range')}
        isLoading={isLoadingGameData}
      />
      <GameStatisticsContentRow
        title={t('win_ways')}
        isLoading={isLoadingGameData}
      />
    </StaggerAnimation>
  );
}
